import { forwardRef, HTMLAttributes, FC } from 'react';
import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { CallInsightPanelLoader } from './call-insight-panel-loader';

const LeadContent: FC<HTMLAttributes<HTMLDivElement>> = ({ children }) => {
  return <div css={styles.leadContent}>{children}</div>;
};

const BodyContent: FC<HTMLAttributes<HTMLDivElement>> = ({ children }) => {
  return <div css={styles.bodyContent}>{children}</div>;
};

const FooterContent: FC<HTMLAttributes<HTMLDivElement>> = ({ children, ...rest }) => {
  return (
    <footer css={styles.footerContent} {...rest}>
      {children}
    </footer>
  );
};

interface CallInsightContentComponent
  extends React.ForwardRefExoticComponent<
    HTMLAttributes<HTMLDivElement> & { isLoading: boolean } & React.RefAttributes<HTMLDivElement>
  > {
  Lead: typeof LeadContent;
  Body: typeof BodyContent;
  Footer: typeof FooterContent;
}

export const CallInsightContent = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement> & { isLoading: boolean }>(
  ({ children, isLoading }, ref) => {
    return (
      <div css={styles.content} ref={ref}>
        {!isLoading ? children : <CallInsightPanelLoader />}
      </div>
    );
  }
) as CallInsightContentComponent;

CallInsightContent.displayName = 'CallInsightContent';
CallInsightContent.Lead = LeadContent;
CallInsightContent.Body = BodyContent;
CallInsightContent.Footer = FooterContent;

const styles = {
  content: css`
    display: flex;
    flex-direction: column;
    padding: ${theme.spacing(3)};
    gap: ${theme.spacing(2)};
    height: 100%;
    overflow: hidden auto;
    scrollbar-gutter: stable;
  `,
  leadContent: css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(2)};
  `,
  bodyContent: css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(2)};
  `,
  footerContent: css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(2)};
    margin-top: auto;
  `,
};
